/* eslint-disable sort-keys */
export const spacing = {
  none: '0px',
  px: '1px',
  '2xs': '2px',
  xs: '4px',
  sm: '8px',
  md: '12px',
  base: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '40px',
  '3xl': '48px',
  '4xl': '64px',
  '5xl': '80px',
  '6xl': '96px',
  '7xl': '128px',
  '8xl': '160px',
};
